import api from './api';

export interface ProgressMilestone {
  id: number;
  month_name: string;
  month_order: number;
  workflow: string;
  name: string;
  description: string | null;
  sort_order: number;
  code_complete: boolean;
  in_test: boolean;
  completed: boolean;
}

export interface ProgressMonth {
  month_name: string;
  month_order: number;
  items: ProgressMilestone[];
}

export interface UpdateMilestoneRequest {
  code_complete?: boolean;
  in_test?: boolean;
  completed?: boolean;
}

const progressTrackerService = {
  async getAll(): Promise<ProgressMonth[]> {
    const response = await api.get('/progress/tracker');
    return response.data.data;
  },

  async update(id: number, data: UpdateMilestoneRequest): Promise<{ success: boolean }> {
    const response = await api.put(`/progress/tracker/${id}`, data);
    return response.data;
  },
};

export default progressTrackerService;
